import * as actions from '../actions'

var defaultState = null

export default function user(state = defaultState, action) {
    switch (action.type) {

        case actions.USER_GET_ONE:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/user.js